import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=5ff90c27&scoped=true"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=5ff90c27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff90c27",
  null
  
)

export default component.exports